module.exports = __webpack_public_path__ + "img/code.05cf7148.jpg";